import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { useGetLayouts, useNavigationBlockContext } from "../../hooks";
import Control from "./Control";
import GroupHeading from "./GroupHeading";
import IndicatorSeparator from "./IndicatorSeparator";
import Menu from "./Menu";
import Option from "./Option";
import Placeholder from "./Placeholder";
import { getOption, getOptions } from "./utils";

type ChangeItem = {
  value: number;
  label: string;
  type: string;
};

const SelectLayout = () => {
  const navigate = useNavigate();
  const { type, id } = useParams();
  const { data } = useGetLayouts();

  const { api, dirty } = useNavigationBlockContext();

  const handleOnChange = (item: ChangeItem) => {
    if (dirty) {
      api.setLeaveMessage(
        "There are unsaved changes. Are you sure you want to discard them and open a different layout?"
      );
    }
    navigate(`/samples/layouts/${item.type}/${item.value}/`);
  };

  const options = getOptions(data);
  const option = getOption(data, type, +(id ?? ""));

  return (
    <Select
      data-testid="select-layout-dropdown"
      components={{
        Control,
        GroupHeading,
        IndicatorSeparator,
        Menu,
        Option,
        Placeholder
      }}
      isSearchable={false}
      options={options}
      value={option}
      placeholder="New Layout"
      theme={theme => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: "#e3e3e3",
          primary: "#e3e3e3"
        }
      })}
      onChange={handleOnChange}
    />
  );
};

export default SelectLayout;
